import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetProperty = async (propertyID) => {
  /**
   * input: null
   * output: property Details object
   * description: fetches property details
   */
  try {
    const propertyCollection = await doc(db, "properties", propertyID);
    const propertySnapshot = await getDoc(propertyCollection);
    let propertyDetails = await propertySnapshot.data();
    propertyDetails = {
      ...propertyDetails,
      id: propertySnapshot.id,
    };

    return propertyDetails;
  } catch (error) {
    console.log(error);
  }
};

export default GetProperty;
